import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import AppState from '@webapp/store/state';

import { motion } from 'framer-motion';

import styled, { css } from 'styled-components';

import BellIcon from '@components/basics/icons/bell';
import { OpenMenu } from '@webapp/store/ui/action-creators';

interface NotificationsMenuProps {
  className?: string;
  hasNotifications: boolean;
  goToNotifications: () => OpenMenu;
}

const mapStateToProps = (state: AppState) => ({
  hasNotifications: state.notifications.items.some(
    (n) => n.status === 'unread'
  ),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToNotifications: () => dispatch(new OpenMenu('NOTIFICATIONS_MENU')),
});

export const NotificationsMenu: React.FC<NotificationsMenuProps> = ({
  className,
  hasNotifications,
  goToNotifications,
}) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith('/notifications');

  const [isHovered, setHover] = React.useState(false);

  return (
    <MenuWrapper
      className={className}
      isHovered={isHovered || isActive}
      onHoverStart={() => setHover(true)}
      onHoverEnd={() => setHover(false)}
      onClick={() => goToNotifications()}
    >
      <BellIcon
        isHovered={isHovered || isActive}
        hasNotification={hasNotifications}
      />
    </MenuWrapper>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsMenu);

const MenuWrapper = styled(motion.div)<{ isHovered: boolean }>`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.midGray};
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  @media ${({ theme }) => theme.device.tablet} {
    width: 40px;
    height: 40px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  ${({ isHovered }) =>
    isHovered
      ? css`
          background-color: ${({ theme }) => theme.colors.primary};
        `
      : null}
`;
